import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GenericError } from '@cian/peperrors/shared';

/* istanbul ignore next */
export var RequestCancelError = /*#__PURE__*/function (_GenericError) {
  function RequestCancelError(configuration) {
    var _this;
    _classCallCheck(this, RequestCancelError);
    _this = _callSuper(this, RequestCancelError, [_objectSpread(_objectSpread({}, configuration), {}, {
      type: 'RequestCancelError'
    })]);
    Object.setPrototypeOf(_this, RequestCancelError.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, RequestCancelError);
    } else {
      _this.stack = new Error().stack;
    }
    return _this;
  }
  _inherits(RequestCancelError, _GenericError);
  return _createClass(RequestCancelError);
}(GenericError);